export default {
  date: 'March 21, 2025',
  title: 'A New Era in Real Estate Sales: Style Switching in 360 Tours',
  description: 'Getfloorplan introduces an innovative feature that helps sell properties faster and more effectively – AI-powered style switching in 3D tours, delivered in just 24 hours.',
  id: 'new-era',
  jsx: () => (
    <div class='novelty__text'>
      <p>
        <b>How Does It Work?</b>
      </p>
      <p>Now, buyers can explore the same property in three different styles with a single click. The virtual tour allows them to instantly switch between interior designs, furniture setups, and color schemes, making it easier to visualize their future home.</p>
      <p>
        <b>Why Is This Important for Sales?</b>
      </p>
      <p>Visualization is key in real estate decision-making. This new feature solves multiple challenges at once:</p>
      <ul style='margin-left: 50px'>
        <li class='margin-none'>
          <b>Increases engagement</b> – buyers spend more time exploring properties with different styles.
        </li>
        <li class='margin-none'>
          <b>Speeds up decision-making</b> – no need for imagination; buyers see ready-made interior options.
        </li>
        <li class='margin-none'>
          <b>Expands the target audience</b> – a single property becomes appealing to buyers with different tastes.
        </li>
        <li class='margin-none'>
          <b>Boosts conversion rates</b> – better presentation increases the likelihood of purchase decisions.
        </li>
      </ul>
      <p>
        <b>Who Benefits from This?</b>
      </p>
      <p>Style switching is especially useful for realtors, developers, and property investors. It enhances property presentation, reduces negotiation time, and improves overall sales efficiency.</p>
      <p>
        <b>Give Buyers More Choice and Sell Faster!</b>
      </p>
      <p>Getfloorplan’s AI technology generates a 3D tour with three design styles in just 24 hours. Try this game-changing tool and see the difference for yourself.</p>
    </div>
  ),
  thumb: 'news/43.webp',
};
